import type { Release } from '../releases.ts';

export default {
  version: '0.22.0',
  date: '2026-10-04',
  title: 'Generate subtitles from the audio',
  summary: [
    'Generate subtitles from the audio with Whisper, on your own server',
    'Choose Finnish, Swedish or English, or let it detect the language',
    'The result is an ordinary track you can edit and export',
    'System status shows the speech service and lists each run',
  ],
  features: [
    'On an asset’s Subtitles tab, “Generate subtitles…” makes a subtitle track from the audio with Whisper, running on your own server (no cloud service): choose Finnish, Swedish or English, or let it detect the language. It takes about as long as the clip, shows what it is doing with a Cancel button, and the result opens as an ordinary track you can edit, export and use in sequences; if it fails you see why and can retry',
    'Subtitles are made from the proxy, so the asset needs audio and a finished proxy; only one run at a time per asset',
    'Administration → System status shows the new speech service (reachable or not), warns when it is down, and lists each run under Jobs as “Subtitles”',
  ],
  fixes: [],
} satisfies Release;
